/** Supported thicknesses for the HITLv2 thickness step. */
export const values = {
	metric: [70, 90, 140, 190],
	imperial: [1.5, 2.5, 3.5, 5.5, 7.25, 9.25, 11.25],
} as const satisfies Record<'metric' | 'imperial', readonly number[]>;

/** Supported nominal CMU wall thicknesses for the HITLv2 thickness step. */
export const cmuValues = {
	metric: [100, 150, 200, 250, 300, 350, 400],
	imperial: [4, 6, 8, 10, 12, 14, 16],
} as const satisfies Record<'metric' | 'imperial', readonly number[]>;
